// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__VYZ3G","header-logo":"Header_header-logo__Mb_JR"};